// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".1744f4a24b9bfc29546b894aa8052726aab53dec.chunk.bundle.js";
};